import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { _subscribe } from '../utils/toast';

const COLORS = {
  error:   { bg: '#fee2e2', border: '#fca5a5', text: '#991b1b' },
  success: { bg: '#dcfce7', border: '#86efac', text: '#166534' },
  info:    { bg: '#dbeafe', border: '#93c5fd', text: '#1e40af' },
};

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    return _subscribe(({ id, message, type }) => {
      setToasts(prev => [...prev, { id, message, type }]);
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4500);
    });
  }, []);

  if (!toasts.length) return null;

  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', bottom: '1.5rem', right: '1.5rem',
      zIndex: 9999, display: 'flex', flexDirection: 'column', gap: '0.5rem',
      maxWidth: '380px', width: '100%',
    }}>
      {toasts.map(t => {
        const c = COLORS[t.type] || COLORS.error;
        return (
          <div key={t.id} style={{
            background: c.bg, border: `1px solid ${c.border}`, color: c.text,
            padding: '0.75rem 1rem', borderRadius: '8px',
            fontSize: '0.875rem', fontWeight: 500,
            boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
            animation: 'fadeInUp 0.2s ease',
          }}>
            {t.message}
          </div>
        );
      })}
    </div>,
    document.body
  );
}
